var utils = require('./utils');

var defaultDepth = 3;
var matchDepthParameter =
  typeof window !== 'undefined' &&
  typeof window.location !== 'undefined' &&
  window.location.search.match(/[?&]depth=(\d+)(?:$|&)/);

if (matchDepthParameter) {
  defaultDepth = parseInt(matchDepthParameter[1], 10);
} else {
  var defaultDepthFromEnv = utils.getEnv('UNEXPECTED_DEPTH');
  if (defaultDepthFromEnv) {
    defaultDepth = parseInt(defaultDepthFromEnv, 10);
  }
}
module.exports = defaultDepth;
